import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ClassNames } from '@emotion/react';
import classNames from 'classnames';
import React from 'react';
import { EMPTY_OBJECT } from '../../utils/object.esm.js';
import Grid from '../_layouts/grid/grid.esm.js';
import Box from '../_primitives/box/box.esm.js';
import Flex from '../_primitives/flex/flex.esm.js';
import FlexInline from '../_primitives/flex/flex-inline.esm.js';
import Label from '../_primitives/label/label.esm.js';
import Text from '../_primitives/text/text.esm.js';

var _excluded = ["children", "label", "labelIndicator", "helperText", "helperTextProps", "validationText", "validationTextProps", "labelRightAddon", "labelInfoIcon", "className", "lineHeight", "gap", "labelProps", "loading", "labelSkeleton"];
var classes = {
  labelMainWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: '100%',
    width: '100%'
  },
  labelWithIndicator: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: '100%'
  },
  labelWrapper: {
    position: 'absolute',
    bottom: '100%'
  },
  labelOverFlow: {
    overflow: 'hidden'
  },
  validationText: {
    position: 'absolute',
    top: '100%',
    wordBreak: 'break-all',
    width: '100%',
    '&.no-wrap': {
      '.csg-tui-icon': {
        alignSelf: 'flex-start',
        transform: 'translateY(0.25em)'
      }
    }
  },
  helperText: {
    position: 'absolute',
    top: '100%',
    wordBreak: 'break-all',
    width: '100%'
  }
};
var FormField = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var children = props.children,
    label = props.label,
    labelIndicator = props.labelIndicator,
    helperText = props.helperText,
    _props$helperTextProp = props.helperTextProps,
    helperTextProps = _props$helperTextProp === void 0 ? EMPTY_OBJECT : _props$helperTextProp,
    validationText = props.validationText,
    _props$validationText = props.validationTextProps,
    validationTextProps = _props$validationText === void 0 ? EMPTY_OBJECT : _props$validationText,
    labelRightAddon = props.labelRightAddon,
    labelInfoIcon = props.labelInfoIcon,
    className = props.className,
    _props$lineHeight = props.lineHeight,
    lineHeight = _props$lineHeight === void 0 ? 'body' : _props$lineHeight,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'xs' : _props$gap,
    labelProps = props.labelProps,
    loading = props.loading,
    labelSkeleton = props.labelSkeleton,
    rest = _objectWithoutProperties(props, _excluded);
  var labelContent = loading ? labelSkeleton : /*#__PURE__*/React.createElement(Text, {
    className: 'csg-tui-label-text',
    ellipsis: true
  }, label);
  return /*#__PURE__*/React.createElement(ClassNames, null, function (_ref) {
    var _cx5;
    var css = _ref.css,
      cx = _ref.cx;
    return /*#__PURE__*/React.createElement(Grid, _extends({
      ref: ref,
      relative: true,
      className: classNames('csg-tui-form-field-grid', className),
      gap: gap,
      alignItems: "center"
    }, rest), labelIndicator || labelRightAddon ? /*#__PURE__*/React.createElement(FlexInline, {
      className: cx(_defineProperty({
        'csg-tui-label-main-wrapper': true
      }, css(classes.labelMainWrapper), true)),
      gap: "xs-3",
      justifyContent: labelRightAddon ? 'space-between' : undefined
    }, /*#__PURE__*/React.createElement(FlexInline, {
      gap: "xs-3",
      className: cx(_defineProperty({
        'csg-tui-label-wrapper': true
      }, css(classes.labelOverFlow), true))
    }, /*#__PURE__*/React.createElement(Label, _extends({
      className: cx(_defineProperty({
        'csg-tui-label': true
      }, css(classes.labelOverFlow), true)),
      ellipsis: false,
      lineHeight: lineHeight
    }, labelProps), labelContent), labelIndicator && /*#__PURE__*/React.createElement(FlexInline, {
      as: "span"
    }, labelIndicator), labelInfoIcon && /*#__PURE__*/React.createElement(FlexInline, {
      as: "span"
    }, labelInfoIcon)), labelRightAddon && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      className: 'csg-tui-label-right-addon',
      pl: "xs"
    }, labelRightAddon)) : /*#__PURE__*/React.createElement(Label, _extends({
      className: cx(_defineProperty({
        'csg-tui-label': true
      }, css(classes.labelMainWrapper), true)),
      ellipsis: false,
      lineHeight: lineHeight
    }, labelProps), labelContent), children, helperText || validationText ? /*#__PURE__*/React.createElement(Text, {
      className: cx((_cx5 = {}, _defineProperty(_cx5, "csg-tui-".concat(helperText ? 'helper-text' : 'validation-text', "-wrapper"), true), _defineProperty(_cx5, css(classes[helperText ? 'helperText' : 'validationText']), true), _defineProperty(_cx5, 'no-wrap', helperText ? helperTextProps.noWrap : validationTextProps.noWrap), _cx5)),
      fontSize: "xxs"
    }, validationText ? /*#__PURE__*/React.createElement(Flex, {
      as: "span",
      alignItems: "center",
      gap: "xs-2",
      mt: "0.125em"
    }, /*#__PURE__*/React.createElement(Text, {
      color: "danger",
      ellipsis: !validationTextProps.noWrap,
      className: cx({
        'csg-tui-validation-text': true
      }),
      alignItems: "center"
    }, validationText)) : /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      ellipsis: !helperTextProps.noWrap,
      className: cx({
        'csg-tui-helper-text': true
      }),
      mt: "0.125em"
    }, helperText)) : null);
  });
});

export default FormField;
//# sourceMappingURL=form-field.esm.js.map
